// extracted by mini-css-extract-plugin
module.exports = {"typicalSignupLink":"styles_typicalSignupLink__UMao8"};